import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const DIALOG_TITLE_CLASS_NAME = 'DialogTitle';
export const DIALOG_TITLE_CLASS_SLOTS = [
	'root',
	'actions',
	'icon',
	'title',
] as const;

export type DialogTitleClassSlot = (typeof DIALOG_TITLE_CLASS_SLOTS)[number];

export interface DialogTitleClasses {
	root: string;
	actions: string;
	icon: string;
	title: string;

	hasIcon: string;
}

export type DialogTitleClassKey = keyof DialogTitleClasses;

export const getDialogTitleUtilityClass = (slot: string) =>
	generateUtilityClass(DIALOG_TITLE_CLASS_NAME, slot);

export const dialogTitleClasses: DialogTitleClasses = generateUtilityClasses(
	DIALOG_TITLE_CLASS_NAME,
	['root', 'actions', 'hasIcon', 'icon', 'title'],
);

export default dialogTitleClasses;
